export const STR_ERRORS = {
    OBQRequestFormatRequiresActiveQuery: "OBQRequestFormatRequiresActiveQuery"
};
//# sourceMappingURL=index.js.map